
<span>
  <material-icon v-if="set === 'material-icon'" :selector="selector" />
  <font-awesome-icon
    v-if="set === 'font-awesome-icon'"
    :selector="selector"
  />
  <themify-icon v-if="set === 'themify-icon'" :selector="selector" />
</span>
